import React from 'react';
import SubmitForm from '../components/appComponents/SubmitForm';
import styled from 'styled-components';
import Menu from '../components/appComponents/Menu';


/* global tw */
const PageWrapper = styled.div`
    ${tw`max-h-screen h-screen w-screen relative overflow-hidden`};
    background: #09080F;
    background-image:
        radial-gradient(ellipse 70% 50% at 50% 0%, rgba(124,58,237,0.25), transparent 65%),
        linear-gradient(180deg, #1A1527 0%, #09080F 100%);
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
`
const componentBuilder = (props)=>(
    
    <PageWrapper>
        {/* <SubmitForm active/> */}
        <Menu/>
    </PageWrapper>
    

);

export default componentBuilder;